import { render, staticRenderFns } from "./AdSpaces.vue?vue&type=template&id=acf16b2a&"
import script from "./AdSpaces.vue?vue&type=script&lang=ts&"
export * from "./AdSpaces.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports